import React from 'react';

import { Navigate } from 'react-router';
import {
    BlankLayout,
    NotFound,
    Forbidden,
    Unauthorized,
    NoPrescriber,
} from '@europrocurement/flexy-components';
import { KeycloakRoute, REALM_DEBUG } from '@europrocurement/l2d-keycloak';
import { Debug, ParcoursFormaliteRouter, SocietesRouter } from '@europrocurement/l2d-modules';
import { getCustomiserState } from '@europrocurement/l2d-domain';
import { grilleTarifaireRouter } from '@europrocurement/l2d-modules/src/modules/GrilleTarifaire/grilleTarifaireRouter';
import FooterAssistanceConnected from './FooterAssistanceConnected';
import { FactureRouter } from '../pages/Factures';

import { version } from '../../package.json';
import { DossierRouter } from '../pages/Dossiers';
import Accueil from '../pages/Accueil/Accueil';
import { OrderRouter } from '../pages/Orders';
import menuEntries from './menuEntries';
import L2DFlayout from './L2DFLayout';
import { RouteErrorBoundary } from './RouteErrorBoundary';

const Router = [
    {
        path: '/',
        element: (
            <L2DFlayout
                menuEntries={menuEntries}
                footerProps={{
                    children: <FooterAssistanceConnected />,
                }}
            />
        ),
        errorElement: <RouteErrorBoundary />,
        children: [
            { path: '/', element: <Navigate to="/accueil" /> },
            {
                path: 'accueil',
                exact: true,
                element: <Accueil />,
                handle: { title: 'Accueil' },
            },
            {
                path: 'debug',
                element:
                    getCustomiserState().env === 'prod' ? (
                        <KeycloakRoute roles={REALM_DEBUG}>
                            <Debug panelEnvironnement={{ version }} />
                        </KeycloakRoute>
                    ) : (
                        <Debug panelEnvironnement={{ version }} />
                    ),
                handle: { title: 'Debug' },
            },
            ParcoursFormaliteRouter,
            DossierRouter,
            OrderRouter,
            SocietesRouter,
            grilleTarifaireRouter,
            FactureRouter,
        ],
    },
    {
        path: '/errors',
        element: <BlankLayout />,
        children: [
            {
                path: '404',
                element: <NotFound />,
                handle: { title: 'Erreur - Page introuvable' },
            },
            {
                path: '403',
                element: <Forbidden />,
                handle: { title: 'Erreur - Accès non autorisé' },
            },
            {
                path: '401',
                element: <Unauthorized />,
                handle: { title: 'Erreur - Authentification nécessaire' },
            },
            {
                path: 'noPrescriber',
                element: <NoPrescriber />,
                handle: { title: 'Erreur - Pas de prescripteurs disponibles' },
            },
        ],
        handle: { title: 'Erreur inconnue' },
    },
    {
        path: '*',
        element: <NotFound />,
        handle: { title: 'Erreur - Page introuvable' },
    },
];

export default Router;
